//公司管理相关请求
import { request } from "@/utils"

export function getCompanyListAPI() {
  return request({
    url: '/crostars-company/list',
    method: 'GET',
  })
}

export function addCompanyAPI(data) {
  return request({
    url: '/crostars-company/add',
    method: 'POST',
    data: data
  })
}

export function updateCompanyAPI(data) {
  return request({
    url: '/crostars-company/update',
    method: 'POST',
    data: data
  })
}

export function listCompanyAPI() {
  return request({
    url: '/crostars-company/list',
    method: 'GET'
  })
}

export function getCompanyDetailAPI(id) {
  return request({
    url: `/crostars-company/get-company-by-id?id=${id}`,
    method: 'POST'
  })
}